import React from 'react';

function Hero(){
    return(
        <div className='frontpage-section'>
            <div className='paragraph' >
            <h3>Coordinate projects, track time, and generate professional reports for clients. </h3>   
            <p>Boost your productivity and streamline your workflow with our all-in-one free time tracking software. </p>
            </div>
            <img className='frontpage-logo' src="./images/TEMPUS_logo.png" alt="Logo"/>
        </div>
    )
}

export default Hero;